import { useDocumentationArea } from "src/apps/hooks/useDocumentationArea";
import { BasicDataForm } from "./BasicDataForm";
import { RepresentedEntityDataForm } from "./RepresentedEntityDataForm/RepresentedEntityDataForm";

export const BasicDataFormSelector = () => {
  const { documentationArea } = useDocumentationArea();

  if (!documentationArea) return null;

  if (documentationArea.isForCompanies()) {
    return <RepresentedEntityDataForm />;
  }

  return <BasicDataForm />;
};
